<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="City Preview"
      id="admin_delete_city_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn @click="$router.go(-1)" small rounded outlined color="default">
        <v-icon left>mdi-trash-can</v-icon> Cancel Delete
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="city.name"
        :icon="'mdi-flag'"
        :img_src="'https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1605849838/botswana%20services/website%20assets/city_generic_js7sxn.jpg'"
        :facts="view_header_facts"
        :description="''"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-trash-can"
      label="Delete City Concent Form "
      id="admin_delete_city_form"
    ></CardedSectionHeader>
    <DeleteConcentForm
      ref_prop="cities_delete_form_ref"
      id="cities_delete_form"
      message="<b>Delete was succesfull</b> <br/> City has been removed"
      :is_loading="is_loading"
      :seed="{city:[$route.params.id]}"
      @on-delete-success="on_success"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-show-loader="$emit('on-show-loader')"
    >
    </DeleteConcentForm>
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedForm from "../../../components/CardedForm";
import ViewHeader from "../../../components/ViewHeader";
import DeleteConcentForm from "../../../components/DeleteConcentForm";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminCategoriesDelete",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    ViewHeader,
    CardedForm,
    DeleteConcentForm
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      city: {
        id: 0,
        name: "",
        short_name: "",
        country: {
            id: 0,
            name: ""
        },
        district: {
            id: 0,
            name: ""
        }
      },
      errors: [],
      message: "",
      not_found: false,
      records: null,
      total: 0,
      scan_limit: 0,
    };
  },
  methods: {
    on_success() {
      //go back to cities list
      this.$router.push("/admin/locations/cities/list");
    },
    load_city() {
      this.$emit("on-show-loader");
      ServerClient.Locations.get_city(
        {
          id: this.$route.params.id,
          is_edit: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          console.log("city to be deleted ", res);
          if (res == null) {
            this.not_found = true;
          } else {
            this.city = res;
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading city details on admin delete city ",
            errors
          );
        }
      );
    },
  },
  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "Short Name",
          val: this.city.short_name,
        },
        { text: "District:", val: this.city.district.name },
        { text: "Country:", val: this.city.country.name },
      ];
      return facts;
    },
  },
  mounted() {
    var city_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Admin delete City",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "Cities",
          disabled: false,
          href: "/admin/locations/cities/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/locations/cities/list/view/" + city_id,
        },
        {
          text: "Delete",
          disabled: true,
          href:"/admin/locations/cities/list/view/"+city_id+"/delete" 
        }
      ],
      navbar_cols: 3
    });
    this.load_city();
  },
};
</script>